import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get, map, concat, isEmpty, isEqual, pull, without, difference, compact, includes } from 'lodash';

const limit = 16;

class FieldComponentFilter extends PureComponent {
  state = {
    idsExcluded: [],
    allSelected: false,
  };

  componentDidMount() {
    const { input, value } = this.props;
    let newValue = get(input, 'value', value);
    if (newValue && newValue.toJS) {
      newValue = newValue.toJS();
    }
    this.handleNewValue(newValue);
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    const newValue = compact(pull(value, 'any'));
    const prevValue = compact(pull(prevProps.value, 'any'));
    if (!isEqual(newValue, prevValue)) {
      this.handleNewValue(value);
    }
  }

  handleNewValue = (value) => {
    const { skipSwitch } = this.props;
    const idsExcluded = without(compact(value), 'any');
    const allSelected = !skipSwitch && isEmpty(idsExcluded);
    this.setState({
      idsExcluded,
      allSelected,
    });
  };

  handleIdsSelectedChange = (allIds, force) => {
    const { onFilterChange, input, isSingleSelection } = this.props;
    const { idsExcluded, allSelected } = this.state;
    let ids = allIds;
    if (isSingleSelection) {
      const isValidIds = Array.isArray(ids) && ids.length > 0;
      ids = isValidIds ? ids[ids.length - 1] : ids;
    }
    if (force || !isEqual(ids, idsExcluded)) {
      let value = allSelected ? map(ids, (id) => `!=${id}`) : ids;
      // NOTE: in case we're using the component inside a redux-form Field
      if (input) {
        input.onChange(value);
      }
      // NOTE: in case we handle the values from the parent
      if (isEmpty(value) && allSelected) {
        value = ['any'];
      }
      if (onFilterChange) {
        onFilterChange(value);
      }
    }
  };

  handleItemSelected = (id, selected, idsSingleSelection) => {
    const { allSelected, idsExcluded: prevIdsSelected } = this.state;
    // Remove other nested IDs in case of single selection
    let idsExcluded = difference(prevIdsSelected, idsSingleSelection);
    if ((selected && !allSelected) || (!selected && allSelected)) {
      // Concat the new ID to the list of IDs
      idsExcluded = concat(idsExcluded, id);
    } else {
      // Exclude the ID from the list of IDs
      idsExcluded = without(idsExcluded, id);
    }
    const force = includes(idsSingleSelection, id);
    this.handleIdsSelectedChange(idsExcluded, force);
    this.setState({ idsExcluded });
  };

  handleAllSelected = (allSelected) => {
    this.setState({
      allSelected,
      idsExcluded: [],
    });
    setTimeout(() => this.handleIdsSelectedChange([], true));
  };

  handleClearItemsSelected = () => {
    const idsExcluded = [];
    this.handleIdsSelectedChange(idsExcluded);
    this.setState({ idsExcluded });
  };

  render() {
    const { FilterComponent, value, ...other } = this.props;
    const { allSelected, idsExcluded } = this.state;

    return (
      <FilterComponent
        allSelected={allSelected}
        idsExcluded={idsExcluded}
        limit={limit}
        onAllSelected={this.handleAllSelected}
        onItemSelected={this.handleItemSelected}
        onClearItemsSelected={this.handleClearItemsSelected}
        value={value}
        {...other}
      />
    );
  }
}

FieldComponentFilter.propTypes = {
  FilterComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  value: PropTypes.arrayOf(PropTypes.string) || PropTypes.object,
  skipSwitch: PropTypes.bool,
  input: PropTypes.object,
  onFilterChange: PropTypes.func,
};

FieldComponentFilter.defaultProps = {
  value: [],
  skipSwitch: false,
  input: undefined,
  onFilterChange: undefined,
};

export default FieldComponentFilter;
